import type { CSSProperties } from "react";
import { css, tokens } from "@balabalabom/ui";
import {
  eventKindLabel,
  resolveEventKind,
  type EventKind,
  type EventKindInput,
} from "../lib/eventKind";

const badgeBase = css({
  display: "inline-flex",
  alignItems: "center",
  padding: "0.2rem 0.55rem",
  borderRadius: "0.375rem",
  fontSize: "0.7rem",
  fontWeight: 700,
  letterSpacing: "0.04em",
  textTransform: "uppercase",
  lineHeight: 1.2,
});

const kindStyles: Record<EventKind, CSSProperties> = {
  storytime: {
    backgroundColor: tokens.colors.surfaces.storytimeAmber,
    color: tokens.colors.brand.deep,
    border: `1px solid ${tokens.colors.surfaces.storytimeGlow}`,
  },
  diy: {
    backgroundColor: tokens.colors.surfaces.techAccent,
    color: "#1e3a5f",
    border: `1px solid ${tokens.colors.surfaces.techDeep}`,
  },
};

type EventKindBadgeProps = {
  event: EventKindInput;
  className?: string;
};

export function EventKindBadge({ event, className }: EventKindBadgeProps) {
  const kind = resolveEventKind(event);
  return (
    <span
      className={className}
      style={{ ...badgeBase, ...kindStyles[kind] }}
    >
      {eventKindLabel(kind)}
    </span>
  );
}

export function eventKindPalette(kind: EventKind): string[] {
  if (kind === "diy") {
    return [
      tokens.colors.surfaces.tech,
      tokens.colors.surfaces.techAccent,
      tokens.colors.surfaces.techDeep,
    ];
  }
  return [
    tokens.colors.surfaces.storytimeSunny,
    tokens.colors.surfaces.storytimeGlow,
    tokens.colors.surfaces.storytimeAmber,
  ];
}
